import {Tile} from '../types/Tile';
import {handleError} from '../../../common/utils/errorHandling';
import httpClient from '../../../common/services/httpClient';

class TilesService {
  public async getAllTiles(): Promise<Tile[]> {
    return handleError(
      () => httpClient.get<Tile[]>('/tiles'),
      'Error fetching tiles:',
      () => []
    );
  }

  public async getTile(id: string): Promise<Tile> {
    return handleError(
      () => httpClient.get<Tile>(`/tiles/${id}`),
      'Error fetching tile:'
    );
  }

  public async createTile(tile: Omit<Tile, 'id'>): Promise<void> {
    const tileWithId = {
      ...tile,
      id: crypto.randomUUID()
    };
    return handleError(
      () => httpClient.post<void>('/tiles', tileWithId),
      'Error creating tile:'
    );
  }

  public async updateTile(tile: Tile): Promise<void> {
    return handleError(
      () => httpClient.put<void>(`/tiles/${tile.id}`, tile),
      'Error updating tile:'
    );
  }

  public async deleteTile(id: string): Promise<void> {
    return handleError(
      () => httpClient.delete<void>(`/tiles/${id}`),
      'Error deleting tile:'
    );
  }

  public async reorderTiles(tileIds: string[]): Promise<void> {
    return handleError(
      () => httpClient.put<void>('/tiles/reorder', tileIds),
      'Error reordering tiles:'
    );
  }
}

const tilesService = new TilesService();
export default tilesService;

